export const APP_LOAD = 'APP_LOAD'
export const REDIRECT = 'REDIRECT'
export const ARTICLE_SUBMITTED = 'ARTICLE_SUBMITTED'
export const SETTINGS_SAVED = 'SETTINGS_SAVED'
export const DELETE_ARTICLE = 'DELETE_ARTICLE'
export const SETTINGS_PAGE_UNLOADED = 'SETTINGS_PAGE_UNLOADED'
export const HOME_PAGE_LOADED = 'HOME_PAGE_LOADED'
export const HOME_PAGE_UNLOADED = 'HOME_PAGE_UNLOADED'
export const ARTICLE_PAGE_LOADED = 'ARTICLE_PAGE_LOADED'
export const ARTICLE_PAGE_UNLOADED = 'ARTICLE_PAGE_UNLOADED'
export const ADD_COMMENT = 'ADD_COMMENT'
export const DELETE_COMMENT = 'DELETE_COMMENT'
export const ARTICLE_FAVORITED = 'ARTICLE_FAVORITED'
export const ARTICLE_UNFAVORITED = 'ARTICLE_UNFAVORITED'
export const ACCOUNT_LIST_EXPORT = 'ACCOUNT_LIST_EXPORT'
export const CLEAR_PROPS = 'CLEAR_PROPS'
export const VIEW_REPORTS_URL = 'VIEW_REPORTS_URL'

export const USER_LIST_PAGE_LOADED = 'USER_LIST_PAGE_LOADED'
export const USER_LIST_NEXT_PAGE_LOADED = 'USER_LIST_NEXT_PAGE_LOADED'
export const USER_LIST_SEARCH_LOADED = 'USER_LIST_SEARCH_LOADED'
export const UPDATE_FIELD_SEARCHTERM = 'UPDATE_FIELD_SEARCHTERM'
export const USER_LIST_PAGE_UNLOADED = 'USER_LIST_PAGE_UNLOADED'
export const USER_PAGE_LOADED = 'USER_PAGE_LOADED'
export const USER_PAGE_UNLOADED = 'USER_PAGE_UNLOADED'
export const USER_CREATE = 'USER_CREATE'
export const UPDATE_FIELD_USER = 'UPDATE_FIELD_USER'
export const USER_CREATE_UNLOADED = 'USER_CREATE_UNLOADED'
export const UPDATE_LOCK_STATUS = 'UPDATE_LOCK_STATUS'
export const RESET_BANK_VERIFICATION = 'RESET_BANK_VERIFICATION'
export const USER_ROLE_UPDATED = 'USER_ROLE_UPDATED'
export const USER_TOGGLE_MFA = 'USER_TOGGLE_MFA'
export const USER_LIST_EXPORT = 'USER_LIST_EXPORT'
export const USER_REFERRER_UPDATED = 'USER_REFERRER_UPDATED'
export const RESEND_VERIFICATION_EMAIL = 'RESEND_VERIFICATION_EMAIL'
export const UPDATE_PHONE_STATUS = 'UPDATE_PHONE_STATUS'
export const UPDATE_MERCHANT_FEE_RATE = 'UPDATE_MERCHANT_FEE_RATE'
export const UPDATE_PHONE = 'UPDATE_PHONE'
export const RESET_TOTP = 'RESET_TOTP'
export const UPDATE_PIN = 'UPDATE_PIN'


export const ACCOUNT_PAGE_LOADED = 'ACCOUNT_PAGE_LOADED'
export const ACCOUNT_NEXT_PAGE_LOADED = 'ACCOUNT_NEXT_PAGE_LOADED'
export const ACCOUNT_PAGE_UNLOADED = 'ACCOUNT_PAGE_UNLOADED'
export const ACCOUNT_GO = 'ACCOUNT_GO'
export const ACCOUNT_WALLET_EXPORT = 'ACCOUNT_WALLET_EXPORT'
export const ACCOUNT_RESET_SYNCTIME = 'ACCOUNT_RESET_SYNCTIME'
export const ACCOUNT_SEARCH = 'ACCOUNT_SEARCH'

export const ACCOUNT_RAW_PAGE_LOADED = 'ACCOUNT_RAW_PAGE_LOADED'
export const ACCOUNT_RAW_PAGE_UNLOADED = 'ACCOUNT_RAW_PAGE_UNLOADED'
export const ACCOUNT_CREATE_PAGE_LOADED = 'ACCOUNT_CREATE_PAGE_LOADED'
export const ACCOUNT_CREATE = 'ACCOUNT_CREATE'
export const ACCOUNT_CREATE_PAGE_UNLOADED = 'ACCOUNT_CREATE_PAGE_UNLOADED'

export const COIN_LIST_PAGE_LOADED = 'COIN_LIST_PAGE_LOADED'
export const COIN_LIST_NEXT_PAGE_LOADED = 'COIN_LIST_NEXT_PAGE_LOADED'
export const COIN_LIST_SEARCH_LOADED = 'COIN_LIST_SEARCH_LOADED'
export const UPDATE_FIELD_TRANSACTION_SEARCHTERM = 'UPDATE_FIELD_TRANSACTION_SEARCHTERM'
export const COIN_LIST_PAGE_UNLOADED = 'COIN_LIST_PAGE_UNLOADED'
export const COIN_TRANSACTION_PAGE_LOADED = 'COIN_TRANSACTION_PAGE_LOADED'
export const COIN_TRANSACTION_PAGE_UNLOADED = 'COIN_TRANSACTION_PAGE_UNLOADED'
export const COIN_TRANSACTION_GO = 'COIN_TRANSACTION_GO'
export const COIN_SEND_LOADED = 'COIN_SEND_LOADED'
export const COIN_SEND = 'COIN_SEND'
export const COIN_SEND_UNLOADED = 'COIN_SEND_UNLOADED'
export const UPDATE_FIELD_SEND = 'UPDATE_FIELD_SEND'

export const TOKEN_LIST_PAGE_LOADED = 'TOKEN_LIST_PAGE_LOADED'
export const TOKEN_LIST_PAGE_UNLOADED = 'TOKEN_LIST_PAGE_UNLOADED'
export const TOKEN_DETAIL_PAGE_LOADED = 'TOKEN_DETAIL_PAGE_LOADED'
export const TOKEN_DETAIL_PAGE_UNLOADED = 'TOKEN_DETAIL_PAGE_UNLOADED'
export const TOKEN_CREATE = 'TOKEN_CREATE'
export const TOKEN_CREATE_PAGE_UNLOADED = 'TOKEN_CREATE_PAGE_UNLOADED'
export const TOKEN_UPDATE = 'TOKEN_UPDATE'
export const TOKEN_APPROVE = 'TOKEN_UPDATE'
export const TOKEN_REJECT = 'TOKEN_REJECT'
export const TOKEN_UNPAUSE = 'TOKEN_UNPAUSE'
export const TOKEN_PAUSE = 'TOKEN_PAUSE'
export const TOKEN_UPDATE_PAGE_UNLOADED = 'TOKEN_UPDATE_PAGE_UNLOADED'
export const TOKEN_LOGS_PAGE_LOADED = 'TOKEN_LOGS_PAGE_LOADED'
export const TOKEN_CREATION_FEE_PAGE_LOADED = 'TOKEN_CREATION_FEE_PAGE_LOADED'
export const TOKEN_CREATION_FEE_PAGE_UNLOADED = 'TOKEN_CREATION_FEE_PAGE_UNLOADED'
export const TOKEN_CREATION_FEE_UPDATE = 'TOKEN_CREATION_FEE_UPDATE'
export const TOKEN_ADMIN_LIST_PAGE_LOADED = 'TOKEN_ADMIN_LIST_PAGE_LOADED'
export const TOKEN_ADMIN_LIST_PAGE_UNLOADED = 'TOKEN_ADMIN_LIST_PAGE_UNLOADED'


export const LOG_LIST_PAGE_LOADED = 'LOG_LIST_PAGE_LOADED'
export const LOG_LIST_NEXT_PAGE_LOADED = 'LOG_LIST_NEXT_PAGE_LOADED'
export const LOG_LIST_PAGE_UNLOADED = 'LOG_LIST_PAGE_UNLOADED'

export const TRANSACTION_LIST_PAGE_LOADED = 'TRANSACTION_LIST_PAGE_LOADED'
export const TRANSACTION_LIST_SEARCH_LOADED = 'TRANSACTION_LIST_SEARCH_LOADED'
export const TRANSACTION_LIST_NEXT_PAGE_LOADED = 'TRANSACTION_LIST_NEXT_PAGE_LOADED'
export const TRANSACTION_LIST_PAGE_UNLOADED = 'TRANSACTION_LIST_PAGE_UNLOADED'
export const UPDATE_FIELD_TRANSACTION_LIST_SEARCHTERM = 'UPDATE_FIELD_TRANSACTION_LIST_SEARCHTERM'
export const TRANSACTION_LIST_EXPORT = 'TRANSACTION_LIST_EXPORT'

export const TRADE_LIST_PAGE_LOADED = 'TRADE_LIST_PAGE_LOADED'
export const TRADE_LIST_SEARCH_LOADED = 'TRADE_LIST_SEARCH_LOADED'
export const TRADE_LIST_NEXT_PAGE_LOADED = 'TRADE_LIST_NEXT_PAGE_LOADED'
export const TRADE_LIST_PAGE_UNLOADED = 'TRADE_LIST_PAGE_UNLOADED'
export const UPDATE_FIELD_TRADE_LIST_SEARCHTERM = 'UPDATE_FIELD_TRADE_LIST_SEARCHTERM'
export const TRADE_DETAIL_PAGE_LOADED = 'TRADE_DETAIL_PAGE_LOADED'
export const TRADE_DETAIL_PAGE_UNLOADED = 'TRADE_DETAIL_PAGE_UNLOADED'

export const TASK_WITHDRAW_LOADED = 'TASK_WITHDRAW_LOADED'
export const TASK_WITHDRAW_SEARCH_LOADED = 'TASK_WITHDRAW_SEARCH_LOADED'
export const TASK_WITHDRAW_NEXT_PAGE_LOADED = 'TASK_WITHDRAW_NEXT_PAGE_LOADED'
export const TASK_WITHDRAW_UNLOADED = 'TASK_WITHDRAW_UNLOADED'
export const TASK_DEPOSIT_LOADED = 'TASK_DEPOSIT_LOADED'
export const TASK_DEPOSIT_SEARCH_LOADED = 'TASK_DEPOSIT_SEARCH_LOADED'
export const TASK_DEPOSIT_NEXT_PAGE_LOADED = 'TASK_DEPOSIT_NEXT_PAGE_LOADED'
export const TASK_DEPOSIT_UNLOADED = 'TASK_DEPOSIT_UNLOADED'

export const TASK_COMPLETE = 'TASK_COMPLETE'
export const TASK_VERIFICATION_LOADED = 'TASK_VERIFICATION_LOADED'
export const TASK_VERIFICATION_SEARCH_LOADED = 'TASK_VERIFICATION_SEARCH_LOADED'
export const TASK_VERIFICATION_NEXT_PAGE_LOADED = 'TASK_VERIFICATION_NEXT_PAGE_LOADED'
export const TASK_VERIFICATION_UNLOADED = 'TASK_VERIFICATION_UNLOADED'
export const TASK_KYC_LOADED = 'TASK_KYC_LOADED'
export const TASK_KYC_SEARCH_LOADED = 'TASK_KYC_SEARCH_LOADED'
export const TASK_KYC_NEXT_PAGE_LOADED = 'TASK_KYC_NEXT_PAGE_LOADED'
export const TASK_KYC_UNLOADED = 'TASK_KYC_UNLOADED'
export const TASK_VERIFICATION_EXPORT = 'TASK_VERIFICATION_EXPORT'
export const TASK_WITHDRAW_EXPORT = 'TASK_WITHDRAW_EXPORT'

export const TASK_GEMINIORDERS_LOADED = 'TASK_GEMINIORDERS_LOADED'
export const TASK_GEMINIORDERS_NEXT_PAGE_LOADED = 'TASK_GEMINIORDERS_NEXT_PAGE_LOADED'
export const TASK_GEMINIORDERS_UNLOADED = 'TASK_GEMINIORDERS_UNLOADED'
export const TASK_GEMINIORDERS_EXPORT = 'TASK_GEMINIORDERS_EXPORT'
export const TASK_GEMINIORDERS_SEARCH_LOADED = 'TASK_GEMINIORDERS_EXPORT'

export const UPDATE_FIELD_TASK_SEARCHTERM = 'UPDATE_FIELD_TASK_SEARCHTERM'

export const DEPOSIT_FILE_UPLOADED = 'DEPOSIT_FILE_UPLOADED'

export const USER_TASK_LIST_LOADED = 'USER_TASK_LIST_LOADED'
export const USER_TASK_LIST_UNLOADED = 'USER_TASK_LIST_UNLOADED'

export const SET_PAGE = 'SET_PAGE'
export const APPLY_TAG_FILTER = 'APPLY_TAG_FILTER'
export const CHANGE_TAB = 'CHANGE_TAB'
export const PROFILE_PAGE_LOADED = 'PROFILE_PAGE_LOADED'
export const PROFILE_PAGE_UNLOADED = 'PROFILE_PAGE_UNLOADED'
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const REGISTER = 'REGISTER'
export const LOGIN_PAGE_UNLOADED = 'LOGIN_PAGE_UNLOADED'

export const GET_PIN_CODE = 'GET_PIN_CODE'
export const LOGIN_PAGE_VERIFY_PIN_CODE = 'LOGIN_PAGE_VERIFY_PIN_CODE'
export const VERIFY_PIN_CODE_UNLOADED = 'VERIFY_PIN_CODE_UNLOADED'
export const VERIFY_USER_PIN = 'VERIFY_USER_PIN'

export const REGISTER_PAGE_UNLOADED = 'REGISTER_PAGE_UNLOADED'
export const ASYNC_START = 'ASYNC_START'
export const ASYNC_END = 'ASYNC_END'
export const EDITOR_PAGE_LOADED = 'EDITOR_PAGE_LOADED'
export const EDITOR_PAGE_UNLOADED = 'EDITOR_PAGE_UNLOADED'
export const ADD_TAG = 'ADD_TAG'
export const REMOVE_TAG = 'REMOVE_TAG'
export const UPDATE_FIELD_AUTH = 'UPDATE_FIELD_AUTH'
export const UPDATE_FIELD_EDITOR = 'UPDATE_FIELD_EDITOR'
export const FOLLOW_USER = 'FOLLOW_USER'
export const UNFOLLOW_USER = 'UNFOLLOW_USER'
export const ON_GUEST = 'ON_GUEST'
export const PROFILE_FAVORITES_PAGE_UNLOADED = 'PROFILE_FAVORITES_PAGE_UNLOADED'

export const ETH_COMMIT_USER_LIST_PAGE_LOADED = 'ETH_COMMIT_USER_LIST_PAGE_LOADED'
export const ETH_COMMIT_USER_LIST_PAGE_UNLOADED = 'ETH_COMMIT_USER_LIST_PAGE_UNLOADED'
export const ETH_COMMIT_TRANSACTION_LIST_PAGE_LOADED = 'ETH_COMMIT_TRANSACTION_LIST_PAGE_LOADED'
export const ETH_COMMIT_TRANSACTION_LIST_PAGE_UNLOADED = 'ETH_COMMIT_TRANSACTION_LIST_PAGE_UNLOADED'
export const BTC_COMMIT_USER_LIST_PAGE_LOADED = 'BTC_COMMIT_USER_LIST_PAGE_LOADED'
export const BTC_COMMIT_USER_LIST_PAGE_UNLOADED = 'BTC_COMMIT_USER_LIST_PAGE_UNLOADED'
export const BTC_COMMIT_TRANSACTION_LIST_PAGE_LOADED = 'BTC_COMMIT_TRANSACTION_LIST_PAGE_LOADED'
export const BTC_COMMIT_TRANSACTION_LIST_PAGE_UNLOADED = 'BTC_COMMIT_TRANSACTION_LIST_PAGE_UNLOADED'

export const CHANGE_DATE_STRINGS = 'CHANGE_DATE_STRINGS'

export const SIGNATURE_PAGE_LOADED = 'SIGNATURE_PAGE_LOADED'
export const GENERATE_SIGNATURE = 'GENERATE_SIGNATURE'
export const SIGNATURE_PAGE_UNLOADED = 'SIGNATURE_PAGE_UNLOADED'
// CONTRACTS
export const CONTRACT_LIST_PAGE_LOADED = 'CONTRACT_LIST_PAGE_LOADED'
export const CONTRACT_LIST_NEXT_PAGE_LOADED = 'CONTRACT_LIST_NEXT_PAGE_LOADED'
export const UPDATE_CONTRACT_SEARCHTERM = 'UPDATE_CONTRACT_SEARCHTERM'
export const CONTRACT_LIST_SEARCH_LOADED = 'CONTRACT_LIST_SEARCH_LOADED'
export const CONTRACT_LIST_PAGE_UNLOADED = 'CONTRACT_LIST_PAGE_UNLOADED'
export const CONTRACT_DETAIL_PAGE_LOADED = 'CONTRACT_DETAIL_PAGE_LOADED'
export const CONTRACT_DETAIL_PAGE_UNLOADED = 'CONTRACT_DETAIL_PAGE_UNLOADED'
export const UPDATE_FIELD_CONTRACT = 'UPDATE_FIELD_CONTRACT'
export const CONTRACT_CREATE = 'CONTRACT_CREATE'
export const CONTRACT_CREATE_UNLOADED = 'CONTRACT_CREATE_UNLOADED'
export const CONTRACT_UPDATE = 'CONTRACT_UPDATE'
export const CONTRACT_UPDATE_UNLOADED = 'CONTRACT_UPDATE_UNLOADED'
export const CONTRACT_DETAIL_LOADED = 'CONTRACT_DETAIL_LOADED'

export const MASTER_ACCOUNT_LIST_PAGE_LOADED = 'MASTER_ACCOUNT_LIST_PAGE_LOADED'
export const MASTER_ACCOUNT_LIST_PAGE_UNLOADED = 'MASTER_ACCOUNT_LIST_PAGE_UNLOADED'
export const MASTER_ACCOUNT_CREATE = 'MASTER_ACCOUNT_CREATE'
export const MASTER_ACCOUNT_CREATE_UNLOADED = 'MASTER_ACCOUNT_CREATE_UNLOADED'
export const MASTER_ACCOUNT_UPDATE = 'MASTER_ACCOUNT_UPDATE'
export const MASTER_ACCOUNT_UPDATE_UNLOADED = 'MASTER_ACCOUNT_UPDATE_UNLOADED'
export const MASTER_ACCOUNT_DETAIL_LOADED = 'MASTER_ACCOUNT_DETAIL_LOADED'
export const MASTER_ACCOUNT_DETAIL_UNLOADED = 'MASTER_ACCOUNT_DETAIL_UNLOADED'
export const MASTER_ACCOUNT_UPDATE_LOADED = 'MASTER_ACCOUNT_UPDATE_LOADED'
export const MASTER_ACCOUNT_MINT_LOADED = 'MASTER_ACCOUNT_MINT_LOADED'
export const MASTER_ACCOUNT_MINT = 'MASTER_ACCOUNT_MINT'
export const MASTER_ACCOUNT_MINT_UNLOADED = 'MASTER_ACCOUNT_MINT_UNLOADED'


export const CHAT_CHANNEL_LIST_PAGE_LOADED = 'CHAT_CHANNEL_LIST_PAGE_LOADED'
export const CHAT_CHANNEL_LIST_PAGE_UNLOADED = 'CHAT_CHANNEL_LIST_PAGE_UNLOADED'
export const CHANNEL_DETAIL_PAGE_LOADED = 'CHANNEL_DETAIL_PAGE_LOADED'
export const CHANNEL_DETAIL_PAGE_UNLOADED = 'CHANNEL_DETAIL_PAGE_UNLOADED'
export const CHANNEL_DETAIL_NEXT_PAGE_LOADED = 'CHANNEL_DETAIL_NEXT_PAGE_LOADED'
export const CHANNEL_DETAIL_SEARCH_LOADED = 'CHANNEL_DETAIL_SEARCH_LOADED'
export const UPDATE_FIELD_CHANNEL_DETAIL_SEARCHTERM = 'UPDATE_FIELD_CHANNEL_DETAIL_SEARCHTERM'
export const CHAT_CHANNEL_CREATE = 'CHAT_CHANNEL_CREATE'
export const CHAT_CHANNEL_CREATE_UNLOADED = 'CHAT_CHANNEL_CREATE_UNLOADED'
export const CHAT_CHANNEL_UPDATE_LOADED = 'CHAT_CHANNEL_UPDATE_LOADED'
export const CHAT_CHANNEL_UPDATE = 'CHAT_CHANNEL_UPDATE'
export const CHAT_CHANNEL_UPDATE_UNLOADED = 'CHAT_CHANNEL_UPDATE_UNLOADED'
export const CHAT_CHANNEL_DELETE = 'CHAT_CHANNEL_DELETE'
export const CHAT_POST_DETAIL_LOADED = 'CHAT_POST_DETAIL_LOADED'
export const CHAT_POST_DETAIL_UNLOADED = 'CHAT_POST_DETAIL_UNLOADED'
export const CHAT_POST_DELETE = 'CHAT_POST_DELETE'
export const CHAT_POST_TOGGLE_DISPLAY = 'CHAT_POST_TOGGLE_DISPLAY'
export const CHAT_TOGGLE_DISPLAY = 'CHAT_TOGGLE_DISPLAY'

export const DEPOSIT_BANK_REFERENCE_CODE_SUBMIT = 'DEPOSIT_BANK_REFERENCE_CODE_SUBMIT'
export const DEPOSIT_BANK_REFERENCE_CODE_UNLOAD = 'DEPOSIT_BANK_REFERENCE_CODE_UNLOAD'

export const RATES_PAGE_LOADED = 'RATES_PAGE_LOADED'
export const RATES_PAGE_UNLOADED = 'RATES_PAGE_UNLOADED'
export const RATE_CREATE_PAGE_LOADED = 'RATE_CREATE_PAGE_LOADED'
export const RATE_CREATE = 'RATE_CREATE'
export const RATE_CREATE_PAGE_UNLOADED = 'RATE_CREATE_PAGE_UNLOADED'
export const RATE_UPDATE_PAGE_LOADED = 'RATE_UPDATE_PAGE_LOADED'
export const RATE_UPDATE = 'RATE_UPDATE'
export const RATE_UPDATE_PAGE_UNLOADED = 'RATE_UPDATE_PAGE_UNLOADED'

export const MERCHANT_LIST_PAGE_LOADED = 'MERCHANT_LIST_PAGE_LOADED'
export const MERCHANT_LIST_PAGE_UNLOADED = 'MERCHANT_LIST_PAGE_UNLOADED'
export const CATEGORY_LIST_PAGE_LOADED = 'CATEGORY_LIST_PAGE_LOADED'
export const CATEGORY_LIST_PAGE_UNLOADED = 'CATEGORY_LIST_PAGE_UNLOADED'
export const CATEGORY_DETAIL_PAGE_LOADED = 'CATEGORY_DETAIL_PAGE_LOADED'
export const CATEGORY_DETAIL_PAGE_UNLOADED = 'CATEGORY_DETAIL_PAGE_UNLOADED'
export const CATEGORY_UPDATE_LOADED = 'CATEGORY_UPDATE_LOADED'
export const CATEGORY_UPDATE_UNLOADED = 'CATEGORY_UPDATE_UNLOADED'
export const CATEGORY_UPDATE = 'CATEGORY_UPDATE'
export const CATEGORY_DELETE = 'CATEGORY_DELETE'
export const PRODUCT_LIST_PAGE_LOADED = 'PRODUCT_LIST_PAGE_LOADED'
export const PRODUCT_LIST_PAGE_UNLOADED = 'PRODUCT_LIST_PAGE_UNLOADED'
export const PRODUCT_DETAIL_PAGE_LOADED = 'PRODUCT_DETAIL_PAGE_LOADED'
export const PRODUCT_DETAIL_PAGE_UNLOADED = 'PRODUCT_DETAIL_PAGE_UNLOADED'
export const PRODUCT_UPDATE_LOADED = 'PRODUCT_UPDATE_LOADED'
export const PRODUCT_UPDATE_UNLOADED = 'PRODUCT_UPDATE_UNLOADED'
export const PRODUCT_UPDATE = 'PRODUCT_UPDATE'
export const PRODUCT_DELETE = 'PRODUCT_DELETE'
export const PRODUCT_LOAD_USER_CATEGORIES = 'PRODUCT_LOAD_USER_CATEGORIES'



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js